import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaUser, FaStore, FaTruck, FaTools, FaWarehouse } from 'react-icons/fa';
import { USER_ROLES } from '../../auth/AuthContext';
import { ONBOARDING_THEME } from './onboardingTheme';

const ROLES = [
  { id: USER_ROLES.CUSTOMER, label: 'Customer', desc: 'Shop for parts and services', icon: FaUser },
  { id: USER_ROLES.VENDOR, label: 'Vendor', desc: 'Sell products', icon: FaStore },
  { id: 'shipping', label: 'Delivery', desc: 'Delivery partner', icon: FaTruck },
  { id: USER_ROLES.MECHANICS, label: 'Mechanic', desc: 'Field expert', icon: FaTools },
  { id: USER_ROLES.GARAGE, label: 'Garage', desc: 'Workshop', icon: FaWarehouse }
];

const Wrap = styled.div`
  height: 100vh; overflow: hidden; background: ${ONBOARDING_THEME.pageBg};
  padding: 24px 20px; display: flex; align-items: center; justify-content: center;
`;
const Card = styled.div`
  max-width: 680px; width: 100%; max-height: calc(100vh - 48px);
  background: ${ONBOARDING_THEME.contentBg}; border-radius: ${ONBOARDING_THEME.radius};
  padding: 28px 24px; box-shadow: ${ONBOARDING_THEME.shadowCard};
  overflow-y: auto;
`;
const Title = styled.h1`
  font-size: 1.5rem; color: ${ONBOARDING_THEME.text}; margin: 0 0 8px 0; text-align: center; font-weight: 700;
`;
const Sub = styled.p` color: ${ONBOARDING_THEME.textMuted}; font-size: 14px; margin: 0 0 28px 0; text-align: center; `;
const Grid = styled.div` display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 14px; margin-bottom: 28px; `;
const RoleBtn = styled.button`
  display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 18px 16px;
  border: 2px solid ${(p) => (p.selected ? ONBOARDING_THEME.accent : ONBOARDING_THEME.border)};
  border-radius: ${ONBOARDING_THEME.radiusSm}; background: ${ONBOARDING_THEME.contentBg};
  cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  &:hover { border-color: ${ONBOARDING_THEME.accent}; background: ${ONBOARDING_THEME.accentLight}; }
`;
const ErrorP = styled.p` color: ${ONBOARDING_THEME.error}; font-size: 14px; margin: 0 0 12px 0; text-align: center; font-weight: 500; `;
const Btn = styled.button`
  width: 100%; padding: 14px; background: ${ONBOARDING_THEME.accent}; color: white; border: none;
  border-radius: ${ONBOARDING_THEME.radiusSm}; font-weight: 600; cursor: pointer; font-size: 15px;
  &:hover { background: ${ONBOARDING_THEME.accentDark}; }
  &:disabled { background: ${ONBOARDING_THEME.textLight}; cursor: not-allowed; }
`;

const roleToPath = (role) => {
  const r = (role || '').toLowerCase();
  if (r === USER_ROLES.CUSTOMER) return '/onboarding/customer';
  if (r === USER_ROLES.VENDOR) return '/onboarding/vendor';
  if (r === 'shipping') return '/onboarding/delivery';
  if (r === USER_ROLES.MECHANICS) return '/onboarding/mechanics';
  if (r === USER_ROLES.GARAGE) return '/onboarding/garage';
  return '/onboarding/customer';
};

export default function OnboardingSelectRole() {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState('');
  const [error, setError] = useState('');

  const handleContinue = () => {
    if (!selectedRole) {
      setError('Please select a role');
      return;
    }
    setError('');
    const path = roleToPath(selectedRole);
    localStorage.setItem('userRole', selectedRole);
    navigate(path, { state: { role: selectedRole }, replace: false });
  };

  return (
    <Wrap className="onboarding-light-page">
      <Card>
        <Title>Who am I?</Title>
        <Sub>Select your role to continue</Sub>
        {error && <ErrorP>{error}</ErrorP>}
        <Grid>
          {ROLES.map(({ id, label, desc, icon: Icon }) => (
            <RoleBtn key={id} type="button" selected={selectedRole === id} onClick={() => setSelectedRole(id)}>
              <Icon size={28} color={selectedRole === id ? ONBOARDING_THEME.accent : ONBOARDING_THEME.textMuted} />
              <span style={{ fontWeight: 600, fontSize: 14, color: ONBOARDING_THEME.text }}>{label}</span>
              <span style={{ fontSize: 12, color: ONBOARDING_THEME.textMuted }}>{desc}</span>
            </RoleBtn>
          ))}
        </Grid>
        <Btn type="button" onClick={handleContinue} disabled={!selectedRole}>
          Continue
        </Btn>
      </Card>
    </Wrap>
  );
}
